import React, { useRef, useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import ChatPanel from './ChatPanel';
import Settings from './Settings';
import Canvas from './Canvas';

import { useAppStore } from '../store/useAppStore';
import { useTranslations } from '../hooks/useTranslations';

const Editor = () => {
  const { 
    sidebarOpen, 
    setSidebarOpen, 

    loading,
    setLoading,

    fetchSessions,
    loadSession,
    createSession,
    currentSessionId,
    sessions
  } = useAppStore();


  const { t } = useTranslations();
  const [showSettings, setShowSettings] = useState(false);

  const prevSessionRef = useRef();


  useEffect(() => {
    fetchSessions()
    setLoading(false)
  }, []);

  useEffect(() => {
    if (currentSessionId) {
      loadSession(currentSessionId)
    } 
  }, []);


  useEffect(() => {
    if (!currentSessionId) {
      console.log('❌ No active session. ');
      createSession(null)
    } 
    prevSessionRef.current = currentSessionId;
  }, [currentSessionId]);

  return (
    <div className={`app-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-left">
          <button 
            className="sidebar-toggle-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>
          <span className="esper-title">Esper</span>
        </div>
        <div className="top-center">
        </div>
        <div className="top-right">
          {/* Active session: {JSON.stringify(currentSessionId)}, {JSON.stringify(loading)},  */}
          {/* Logout button moved to sidebar */}
        </div>
      </div>

      {/* Main Container */}
      <div className="main-container">
        <Sidebar onOpenSettings={() => setShowSettings(true)} />
        <Canvas />
        <ChatPanel />
      </div>

      {/* Settings Modal - Now properly positioned outside sidebar */}
      <Settings isOpen={showSettings} onClose={() => setShowSettings(false)} />


    </div>
  );
};

export default Editor; 